/**
 * MobileBottomNavbar Component displays the bottom navigation bar for mobile devices.
 */

import React, { useState } from 'react';
import MenuItem from './MenuItem';
import { Box, Grid, Divider } from '@chakra-ui/react';
import { GetAuthData } from '../../../../misc/GetAuthData';
import {
  IoHomeOutline,
  IoBookOutline,
  IoVideocamOutline,
  IoInformationCircleOutline,
  IoPersonOutline,
  IoHome,
  IoBook,
  IoVideocam,
  IoInformationCircle,
  IoPerson,
} from 'react-icons/io5';

/**
 * MobileBottomNavbar component.
 *
 * @returns {React.FC} The MobileBottomNavbar component.
 * @author Bagas Prasetyadi
 */

const MobileBottomNavbar: React.FC = () => {
  const [menuSelected, setMenuSelected] = useState<string>(
    window.location.pathname.substring(1)
  );

  const renderColor = (menu: string) => {
    return menuSelected === menu ? 'green.700' : 'black';
  };

  const renderIcon = (menu: string) => {
    switch (menu) {
      case '':
        return menuSelected === menu ? IoHome : IoHomeOutline;
      case 'pelatihan':
        return menuSelected === menu ? IoBook : IoBookOutline;
      case 'video-course':
        return menuSelected === menu ? IoVideocam : IoVideocamOutline;
      case 'pengetahuan':
        return menuSelected === menu
          ? IoInformationCircle
          : IoInformationCircleOutline;
      case 'profile':
        return menuSelected === menu ? IoPerson : IoPersonOutline;
      default:
        return IoHomeOutline;
    }
  };

  const menuItems = [
    {
      menuSelected: '',
      title: 'Beranda',
      color: renderColor(''),
      icon: renderIcon(''),
    },
    {
      menuSelected: 'pelatihan',
      title: 'Pelatihan',
      color: renderColor('pelatihan'),
      icon: renderIcon('pelatihan'),
    },
    {
      menuSelected: 'pengetahuan',
      title: 'Pengetahuan',
      color: renderColor('pengetahuan'),
      icon: renderIcon('pengetahuan'),
    },
    {
      menuSelected: 'profile',
      title: 'Akun',
      color: renderColor('profile'),
      icon: renderIcon('profile'),
    },
  ];

  return (
    <Box
      position="sticky"
      bottom={0}
      bg="white"
      zIndex={40}
      maxH={100}
      display={{
        base: GetAuthData() !== null ? 'block' : 'none',
        md: 'none',
      }}
    >
      <Divider orientation="horizontal" />
      <Box p={4}>
        <Grid templateColumns="repeat(4, 1fr)" gap={2}>
          {menuItems.map((item) => (
            <MenuItem
              key={item.menuSelected}
              setMenuSelected={setMenuSelected}
              menuSelected={item.menuSelected}
              title={item.title}
              color={item.color}
              icon={item.icon}
            />
          ))}
        </Grid>
      </Box>
    </Box>
  );
};

export default MobileBottomNavbar;
